export const Site = Object.freeze({
  RusPropusk: 'ruspropusk',
  PropuskPro: 'propusk-pro',
  ProveritPropusk: 'proverit-propusk'
});

export const SiteName = Object.freeze({
  [Site.PropuskPro]: 'Пропуск-про',
  [Site.RusPropusk]: 'Руспропуск',
  [Site.ProveritPropusk]: 'Проверить пропуск'
});

export const SitesList = Object.freeze(Object.keys(Site).map(key => ({ key: Site[key], name: SiteName[Site[key]] })))

export const isValidSite = (name) => Object.values(Site).includes(name);



// WEBPACK FOOTER //
// ./src/models/site.js